import {
  ADD_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_REQUEST,
  ADD_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_SUCCESS,
  ADD_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_FAIL,
} from '../actions/addTradeAgreementSellOutValidator';

const initialState = {
  loading: false,
};

const addTradeAgreementsSellOutValidatorReducer = (state = initialState, action) => {
  const { type } = action;
  //const { validators, counter } = state;
  switch (type) {
    case ADD_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADD_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_SUCCESS:
    case ADD_TRADE_AGREEMENT_SELL_OUT_VALIDATOR_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default addTradeAgreementsSellOutValidatorReducer;
